<template>
  <div :class="['dot-container', isMoving ? 'moving' : '']">
    <div v-for="i in 8" :key="i" 
      :class="['dot-wrap', `dot-${i}`]"
      :style="{
        'cursor': isMoving ? cursorList[current] : cursorList[i]
      }"
      @mousedown="startDown($event, i)"
      @touchstart="startDown($event, i)"
    >
      <div class="dot"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ControlDots',
  data() {
    return {
      current: 0,
      isMoving: false,
      startPosition: {
        x: 0,
        y: 0,
      },
      cursorList: {
        1: 'nwse-resize',
        2: 'ns-resize',
        3: 'nesw-resize',
        4: 'ew-resize',
        5: 'nwse-resize',
        6: 'ns-resize',
        7: 'nesw-resize',
        8: 'ew-resize',
      },
    };
  },
  mounted() {
    document.body.addEventListener('mousemove', this.startMove, false);
    document.body.addEventListener('mouseup', this.startEnd, false);
    document.body.addEventListener('mouseleave', this.startEnd, false);
    document.body.addEventListener('touchmove', this.startMove, false);
    document.body.addEventListener('touchend', this.startEnd, false);
    document.body.addEventListener('touchcancel', this.startEnd, false);

    this.$once('hook:beforeDestroy', () => {
      document.body.removeEventListener('mousemove', this.startMove);
      document.body.removeEventListener('mouseup', this.startEnd);
      document.body.removeEventListener('mouseleave', this.startEnd);
      document.body.removeEventListener('touchmove', this.startMove);
      document.body.removeEventListener('touchend', this.startEnd);
      document.body.removeEventListener('touchcancel', this.startEnd);
    });
  },
  methods: {
    startDown(e, i) {
      e.preventDefault();
      this.isMoving = true;

      let pageX;
      let pageY;

      if (e.touches) {
        pageX = e.touches[0].clientX;
        pageY = e.touches[0].clientY;
      } else {
        pageX = e.pageX;
        pageY = e.pageY;
      }

      this.startPosition.x = pageX;
      this.startPosition.y = pageY;
      this.current = i;

      this.$emit('movestart');
    },

    startMove(e) {
      if (this.isMoving) {
        let pageX;
        let pageY;

        if (e.touches) {
          pageX = e.touches[0].clientX;
          pageY = e.touches[0].clientY;
        } else {
          pageX = e.pageX;
          pageY = e.pageY;
        }

        document.body.style.cursor = this.cursorList[this.current];
        this.$emit('move', {
          x: pageX - this.startPosition.x,
          y: pageY - this.startPosition.y,
          i: this.current,
        });
      }
    },

    startEnd(e) {
      if (this.isMoving) {
        e.preventDefault();
        document.body.style.cursor = 'initial';
        this.$emit('moveend');
        this.isMoving = false;
        this.current = 0;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.dot-container {
  &.moving {
    position: absolute;
    z-index: 11;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &::after {
    content: '';
    position: absolute;
    top: -3px;
    right: -3px;
    bottom: -3px;
    left: -3px;
    border: 3px solid #FFA700;
  }
}

.dot-wrap {
  position: absolute;
  z-index: 3;
  width: 30px;
  height: 30px;
}

.dot {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 15px;
  height: 15px;
  border: 3px solid #FFA700; 
  background-color: #fff;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.dot-1 {
  top: -16px;
  left: -16px;
}

.dot-2 {
  top: -16px;
  left: calc(50% - 15px);
}

.dot-3 {
  top: -16px;
  right: -16px;
}

.dot-4 {
  top: calc(50% - 15px);
  right: -16px;
}

.dot-5 {
  bottom: -16px;
  right: -16px;
}

.dot-6 {
  left: calc(50% - 15px);
  bottom: -16px;
}

.dot-7 {
  left: -16px;
  bottom: -16px;
}

.dot-8 {
  left: -16px;
  top: calc(50% - 15px);
}
</style>